import { sortBy, startCase } from 'lodash';
import { FIELD_ID_ASSIGNEE, FieldType, filterableFieldType, NativeFieldName, SourceType, UserTypeFields } from 'api/tasks/field-meta';
export { FIELD_ID_ASSIGNEE, FieldType, filterableFieldType, NativeFieldName, SourceType, UserTypeFields };
export const UserId = (id, user)=>user ? [
        'user',
        id,
        user
    ] : [
        'user',
        id
    ];
export const TeamId = (id)=>[
        'team',
        id
    ];
export const AssigneeValue = {
    toString: (value)=>value.join('_'),
    fromString: (value)=>{
        const [type, id] = value.split('_');
        return [
            type,
            parseInt(id, 10)
        ];
    },
    isSame: (a, b)=>a[0] === b[0] && a[1] === b[1],
    toSquad: (values)=>{
        return {
            users: values.filter(([type])=>type === 'user').map(([, userId])=>({
                    userId
                })),
            teams: values.filter(([type])=>type === 'team').map(([, teamId])=>({
                    teamId
                }))
        };
    }
};
export const AssigneeField = (users, teams)=>({
        fieldId: FIELD_ID_ASSIGNEE,
        private: false,
        type: FieldType.Assignee,
        customField: false,
        fieldName: 'assignee',
        metaData: {
            users,
            teams
        },
        fieldGroup: '_native',
        sourceType: SourceType.Task
    });
export const groupedFieldsTransformerFunction = (fieldOption)=>({
        ...fieldOption,
        label: fieldOption.label || startCase(fieldOption.id),
        options: sortBy(fieldOption.options.map((_option)=>({
                label: _option.fieldLabel,
                value: _option.fieldId,
                ..._option
            })), ({ fieldLabel, fieldName })=>fieldLabel !== null && fieldLabel !== void 0 ? fieldLabel : startCase(fieldName))
    });
